export default __webpack_public_path__ + "static/media/Bookcrossing.a8fe8e50.jpg";